import React from 'react';
import { FadeIn } from './FadeIn';
import { GiftIcon, MapIcon, BookMarkedIcon, FileTextIcon, HeartIcon, CheckSquareIcon } from 'lucide-react';
export function Bonuses() {
  const bonuses = [{
    icon: <MapIcon className="w-6 h-6" data-id="element-15" />,
    label: 'Bono 1',
    title: 'Guía Rápida: ¿Qué Hacer Primero?',
    desc: 'El GPS del Megapack. Test de diagnóstico, rutas de lectura por nivel, 3 cambios inmediatos para tu próxima clase y plan de 7 días. Para que no te abrumés y empezás a aplicar desde hoy.'
  }, {
    icon: <BookMarkedIcon className="w-6 h-6" data-id="element-16" />,
    label: 'Bono 2',
    title: 'Diccionario de Metáforas y Frases de Poder',
    desc: 'Más de 200 frases y metáforas organizadas por track. Listas para usar en el momento exacto que tu clase las necesita. No es un diccionario técnico. Es tu arsenal verbal completo.'
  }, {
    icon: <FileTextIcon className="w-6 h-6" data-id="element-17" />,
    label: 'Bono 3',
    title: 'Scripts de Storytelling',
    desc: '22 historias cortas listas para usar en clase. Una para cada momento exacto. Porque tus alumnos no recuerdan cuánto peso usaron. Recuerdan cómo les hiciste sentir.'
  }, {
    icon: <HeartIcon className="w-6 h-6" data-id="element-18" />,
    label: 'Bono 4',
    title: 'Guía de Nutrición y Autocuidado',
    desc: 'El manual de combustible del instructor. Nutrición pre y post clase, recuperación, suplementación básica y gestión del sueño. Porque no podés dar energía si no la tenés.'
  }, {
    icon: <CheckSquareIcon className="w-6 h-6" data-id="element-19" />,
    label: 'Bono 5',
    title: 'Checklists Zero Stress',
    desc: 'Tu sistema de preparación completo. Una checklist para cada momento: 48hs antes, 24hs, día de clase, 60 minutos antes, 15 minutos, durante y post-clase. Para que nunca más improvises.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-pump-surface" data-id="element-20">
      <div className="max-w-6xl mx-auto" data-id="element-21">
        <FadeIn data-id="element-22">
          <div className="text-center mb-16" data-id="element-23">
            <div className="inline-flex items-center justify-center gap-2 bg-pump-gold/10 text-pump-gold px-4 py-2 rounded-full font-bold mb-6 border border-pump-gold/20" data-id="element-24">
              <GiftIcon className="w-5 h-5" data-id="element-25" />
              <span data-id="element-26">5 BONOS DE ALTO IMPACTO</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-display font-bold text-white max-w-3xl mx-auto" data-id="element-27">
              Y además de los 6 tomos, recibís 5 bonos diseñados para que cada
              uno solo ya valga el precio del protocolo completo.
            </h2>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-28">
          {bonuses.map((bonus, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-29">
              <div className="bg-pump-dark border border-pump-muted p-6 sm:p-8 rounded-2xl h-full flex flex-col hover:border-pump-gold/30 transition-colors" data-id="element-30">
                <div className="flex items-center gap-3 mb-4" data-id="element-31">
                  <div className="bg-pump-surface w-12 h-12 rounded-full flex items-center justify-center text-pump-gold border border-pump-muted shrink-0" data-id="element-32">
                    {bonus.icon}
                  </div>
                  <span className="text-pump-gold font-bold text-xs uppercase tracking-widest" data-id="element-33">
                    {bonus.label}
                  </span>
                </div>
                <h3 className="text-xl font-display font-bold text-white mb-3" data-id="element-34">
                  {bonus.title}
                </h3>
                <p className="text-gray-400 leading-relaxed flex-grow" data-id="element-35">
                  {bonus.desc}
                </p>
              </div>
            </FadeIn>)}
          <div className="hidden lg:block" data-id="element-36" />
        </div>
      </div>
    </section>;
}